import { logger } from './logger';
import { parseHttpResponse } from './parse-http-response';
import { withPoll } from './with-poll';
import { withRetry } from './with-retry';
import { withTimeout } from './with-timeout';
export async function performHttpAction(config) {
    let response;
    if (config.pollingConfiguration) {
        response = await withPoll(() => performFetch(config), config.pollingConfiguration, config.requestTimeoutInMilliseconds);
    }
    else {
        response = await withRetry(() => {
            return withTimeout(() => performFetch(config), config.requestTimeoutInMilliseconds);
        }, config.maxAttempts);
    }
    return config.parseResponse ? parseHttpResponse(response) : response;
}
const performFetch = async (config) => {
    const { url, body, credentials, httpMethod, headers } = config;
    logger.debug(`Starting ${httpMethod} for url '${url}'`);
    const response = await fetch(url, {
        method: httpMethod,
        headers,
        credentials,
        body
    });
    logger.debug(`Finished ${httpMethod} for url '${url}' with status ${response.status}.`);
    return response;
};
//# sourceMappingURL=perform-http-action.js.map